export enum DailyLoadFileType {
  PRE_TRANSFORM = 'PRE_TRANSFORM',
  UFF_TRANSFORMATION = 'UFF_TRANSFORMATION',
  FIDIL = 'FIDIL',
  CREDIT_CARD = 'CREDIT_CARD',
}

export default DailyLoadFileType;
